<template>
    <div class="u-wrapper">
        <div class="box">
            <img
                src="//img.58cdn.com.cn/git/teg-app-fe/wuba-questionnaire-outside/img/logo2020.svg"
                alt
                class="logo"
            />
            <div class="content">
                <div>
                    <p class="title">尊敬的58问卷用户：</p>
                    <p>为了给您提供更好的服务，58问卷正在紧张升级中，开放时间待定。</p>
                    <p style="margin-bottom: 28px;">我们期待，今后以全新的面貌迎接您！</p>
                    <p>升级期间，有任何疑问或建议，您都可通过以下途径与我们联系：</p>
                    <p>1、点此<span style="color:#ff552d;cursor: pointer;" @click="feedback">线上反馈</span></p>
                    <p>2、发送邮件至 hanxiaoting@58.com</p>
                    <p>3、58内部用户可联系OA：hanxiaoting</p>
                </div>
                <div class="team">
                    <img src="https://wos.58cdn.com.cn/cDazYxWcDHJ/picasso/bc3kpm91.png" alt="">
                    <div class="team-name">
                        <p>58问卷团队</p>
                        <p>2022年3月1日</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    methods:{
        feedback(){
            window.open("https://survey.58.com/?id=1027681&hash=gdry");
        }
    }
}
</script>

<style lang="scss">
.u-wrapper {
    width: 100%;
    height: 100%;
    background: linear-gradient(
        180deg,
        rgba(255, 242, 237, 1) 0%,
        rgba(255, 255, 255, 1) 21%,
        rgba(255, 255, 255, 1) 100%
    );
    position: relative;
    .box {
        margin: 0 auto;
        margin-top: 200px;
        width: 484px;
        position: absolute;
        left: 0;
        right: 0;
        .logo {
            display: block;
            height: 75px;
            margin: 0 auto;
            margin-bottom:77px;
        }
        .content {
            p {
                font-family: PingFangSC-Regular;
                font-size: 16px;
                font-weight: 400;
                line-height: 18px;
                color: #666666;
                margin-bottom: 12px;
            }
            .title{
                font-family: PingFangSC-Medium;
                font-weight: 400;
                margin-bottom: 20px;
            }
            .team{
                position: absolute;
                right: 0;
                width: 235px;
                height: 100px;
                .team-name{
                    position: absolute;
                    display: inline-block;
                    right: 0;
                    bottom: 0;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/upgrade.vue